module.exports = __webpack_public_path__ + "assets/isolines-w-bg-d6be607be417d39a969d56a5c388ff3c.png";